interface HeadlessQueryParams {
  timeZoneOffset: string;
  userId: string;
  language: string;
}

/* We will read the headless params through pure js, because if we need to
 * read it from the activatedRoute, it will take time to fetch this config after subscribe
 * and we need this information on app load
 */
function _getHeadlessQueryParams(): HeadlessQueryParams {
  // Get the query string from the current URL
  const queryString = window.location.search;

  // Create a URLSearchParams object from the query string
  const queryParams = new URLSearchParams(queryString);

  // Create an object to store the key-value pairs of query parameters
  const params = {};

  // Iterate over each query parameter and store it in the params object
  queryParams.forEach((value, key) => {
    params[key] = value;
  });

  return {
    timeZoneOffset: params['timeZoneOffset'] ?? null,
    userId: params['userId'] ?? null,
    language: params['language'] ?? 'en',
  };
}

function getHeadlessQueryParamsMemo() {
  let params: HeadlessQueryParams;
  return () => {
    if (params) {
      return params;
    }
    params = _getHeadlessQueryParams();
    return params;
  };
}

export const headLessQueryParams = getHeadlessQueryParamsMemo();
